import { render, staticRenderFns } from "./BaseListCard.vue?vue&type=template&id=767e3e5e"
import script from "./BaseListCard.vue?vue&type=script&lang=js"
export * from "./BaseListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports